export const textSwe=[
"Sök efter riksdagsledamot", 
"Sortera"
]